<template>
    <v-container class="mb-12">
        <v-row justify="center">
            <v-col cols="12" md="8" lg="6">
                <v-card color="primary" dark>
                    <v-card-title class="d-block text-center secondary--text">RECIBIR</v-card-title>
                    <v-card-text class="text-center pa-6">
                        <vue-qrcode :value="accountTag" :scale="8" :margin="0" :version="3"/>
                        <h2 class="secondary--text mt-4 mb-2">{{ accountTag }}</h2>
                        <p class="mb-0 white--text">Comparte este QR o tu nickname para recibir pagos en tu wallet.</p>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            block
                            color="secondary"
                            class="primary--text font-weight-bold"
                            v-clipboard:copy="accountTag"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">
                            <v-icon left>mdi-content-copy</v-icon> Copiar nickname
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import VueQrcode from 'vue-qrcode';

export default {
    name: "WalletReceive",
    props: ['user'],
    components: { VueQrcode },
    computed: {
        accountTag() {
            return '$' + (this.user.nickname || (this.user.id ? String(this.user.id).padStart(5, '0') : ''));
        }
    },
    methods: {
        onCopy() {
            this.$toast.success('Se copió en el portapapeles.', {icon: 'mdi-content-copy'});
        },
        onError() {
            this.$toast.error('No se copió en el portapapeles.', {icon: 'mdi-content-copy'});
        }
    }
}
</script>
